import React__default from 'react';
import _s from 'styled-components';

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
const Overlay = ({
  onPress,
  testID
}) => {
  return /*#__PURE__*/React__default.createElement(Container, {
    onClick: onPress,
    "data-testid": testID
  });
};
const Container = styled.div`
  background-color: ${({
  theme
}) => theme.overlay};
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: ${({
  theme
}) => theme.zIndices.modal};
`;

export { Overlay as default };
//# sourceMappingURL=Overlay.js.map
